<rt-infobox
  [isDismissible]="false"
  [type]="'transparent'"
  iconName="upgrade"
  iconSize="small"
  class="infobox"
>
  <div layout layout-align-items-center layout-space-between>
    <div>
      {{ 'app.spam_verification.trial_provider.infobox_prefix' | translate }}
      {{
        !externalMailboxConnected()
          ? ('app.spam_verification.trial_provider.infobox_suffix' | translate)
          : ''
      }}
      <a rtHelpArticle="mailboxSync" class="link">{{ 'app.common.learn_more' | translate }}</a>
    </div>
    <ng-content />
  </div>
</rt-infobox>
